import { getUserInfo, logout } from "@/api/user";
import {
  getToken,
  getFullName,
  getNumSystem,
  getUnread,
  setToken,
  setSlider,
  removeToken,
  getImage,
} from "@/utils/auth";
export default {
  state: {
    ImageUrl: getImage(),

    Num_System: getNumSystem(),
    UnreadMessagesCount: getUnread(),

    token: getToken(),
    FullName: getFullName(),

    userInfo: {},
    menuOptions: [
      {
        title: "شخصی",
        icon: "user",
      },
      {
        icon: "home",
        title: "خانه",
        route: "/index",
        color: "#0d5259",
      },
      {
        icon: "user",
        title: "اطلاعات شخصی",
        route: "/info",
        color: "#59520d",
      },
      {
        icon: "user-cog",
        title: "ویرایش اطلاعات شخصی",
        route: "https://profile.hozehkh.com",
        color: "#6C2D89",
      },
      {
        icon: "comment",
        title: "درخواست‌ها و ارتباط با ما",
        route: "/new-contact-v2",
        color: "#36214A",
      },

      {
        icon: "credit-card",
        title: "مالی و شهریه",
        route: "/salary",
        color: "#783464",
      },
      {
        icon: "file-alt",
        title: "سوابق و رزومه",
        route: "/resume",
        needActive: true,
        color: "#6b7e0A",
      },
      {
        icon: "building",
        title: "هزینه مسکن",
        route: "/home-request-active",
        needActive: true,
        color: "#36375B",
      },

      {
        icon: "user-circle",
        title: "تغییر تصویر",
        route: "/change-picture-request",
        needActive: true,
        color: "#2B7763",
      },
      {
        icon: "heart",
        title: "تغییر وضعیت تاهل",
        route: "/marital-request",
        needActive: true,
        color: "#53497B",
      },

      {
        icon: "plane",
        title: "خروج از کشور و سربازی",
        route: "/khorooj-index",
        needActive: true,
        color: "#2D4F08",
      },
      {
        icon: "mosque",
        title: "گواهی تلبس",
        route: "/talabbos-index",
        needActive: true,
        color: "#782245",
      },
      {
        icon: "envelope",
        title: "پیام ها",
        route: "/messages",
        value: getUnread().toString(),
        color: "#5C4151",
      },
      {
        icon: "utensils",
        title: "رزرو غذا",
        route: "https://food.hozehkh.com/",
        color: "#CB6015",
      },
      {
        title: "امور تحصیلی",
        needActive: true,
        icon: "book-open",
      },
      {
        icon: "file",
        title: "کارنامه",
        route: "/cycles",
        needActive: true,
        color: "#585150",
      },
      {
        icon: "chart-area",
        title: "وضعیت پایه ها",
        route: "/payeh",
        needActive: true,
        color: "#291E68",
      },
      {
        icon: "book",
        title: "انتخاب درس",
        route: "/open-cycles",
        needActive: true,
        color: "#3C4A14",
      },
      {
        icon: "times-circle",
        title: "حذف درس",
        route: "/delete-course-request",
        needActive: true,
        color: "#66220D",
      },
      {
        icon: "id-card",
        title: "کارت ورود به جلسه",
        route: "/exams",
        needActive: true,
        color: "#84198C",
      },
      {
        icon: "microphone",
        title: "امتحان شفاهی",
        route: "/shafahi",
        needActive: true,
        color: "#72656E",
      },
      {
        icon: "check-double",
        title: "ثبت حضور و غیاب",
        route: "/hozoor",
        needActive: true,
        color: "#423D75",
      },
      // {
      //   icon: "calendar-times",
      //   title: "غیبت های کلاسی",
      //   route: "/gheibat",
      //   needActive: true,
      //   color: "#470245",
      // },

      {
        icon: "hand-paper",
        title: "اعتراض به نمره",
        route: "/eteraz",
        needActive: true,
        color: "#85144F",
      },
      {
        icon: "file-signature",
        title: "مدرک تحصیلی",
        route: "/madrak",
        needActive: true,
        color: "#63894B",
      },
      {
        icon: "user-clock",
        title: "درخواست مرخصی",
        route: "/morkhasi-request",
        needActive: true,
        color: "#6C3613",
      },
      {
        icon: "university",
        title: "تحصیل همزمان",
        route: "/tahsil-request",
        needActive: true,
        color: "#7B5143",
      },
      {
        icon: "chalkboard",
        title: "درخواست تدریس",
        route: "/tadris-request",
        needActive: true,
        color: "#44337F",
      },
      {
        icon: "chalkboard-teacher",
        title: "مجوز تدریس",
        route: "/tadris-permission-request",
        needActive: true,
        color: "#3E1254",
      },
      {
        icon: "exchange-alt",
        title: "درخواست انتقال",
        route: "/transfer-request",
        needActive: true,
        color: "#7E874A",
      },

      {
        icon: "poll",
        title: "نظرسنجی",
        route: "/poll",
        needActive: true,
        color: "#6B556A",
      },
      {
        icon: "comments",
        title: "مباحثات",
        route: "/discussion",
        needActive: true,
        color: "#7B0124",
      },

      {
        icon: "file-word",
        title: "پایان نامه",
        route: "https://madarej.hozehkh.com/",
        color: "#714A0C",
      },
      {
        icon: "book-open",
        title: "رشته های تخصصی",
        route: "/aboutus/majors",
        color: "#345678",
      },
      {
        icon: "list",
        title: "آیین نامه ها",
        route: "/aboutus/ayinnamehs",
        color: "#0E814C",
      },
      {
        icon: "school",
        title: "معرفی مدارس",
        route: "/aboutus/schools",
        color: "#722435",
      },

      {
        title: "سایر",
        icon: "file-alt",
      },
      {
        icon: "book",
        title: "دورۀ غیر تحصیلی",
        route: "/registers",
        color: "#0C6942",
      },
      {
        icon: "child",
        title: "اعزام مبلغ",
        route: "/ezam",
        color: "#0C6942",
      },

      {
        icon: "phone",
        title: "شماره های تماس",
        route: "/contactus",
        color: "#360F67",
      },
      {
        icon: "link",
        title: "آموزش مجازی مرکز مدیریت",
        route: "https://lms2.hozehkh.com/",
        color: "#714A0C",
      },
      {
        icon: "link",
        title: "لینک های مفید",
        route: "/links",
        color: "#506A7C",
      },
      {
        icon: "link",
        title: "طرح نور",
        route: "/noor",
        needActive: true,
        needNoor: true,
        color: "#240A2C",
      },

      {
        icon: "link",
        title: "نسخه قدیم",
        route: "https://hozehkh.com/Students/",
        needActive: true,
        color: "#145A4C",
      },
    ],
  },

  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },

    SET_FULLNAME: (state, FullName) => {
      state.FullName = FullName;
    },
    SET_NUM_SYSTEM: (state, Num_System) => {
      state.Num_System = Num_System;
    },

    SET_AVATAR: (state, ImageUrl) => {
      state.ImageUrl = ImageUrl;
    },
    SET_UNREAD_MESSAGE_COUNT: (state, UnreadMessagesCount) => {
      if (UnreadMessagesCount != undefined) {
        state.UnreadMessagesCount = UnreadMessagesCount;
        state.menuOptions[12].value = UnreadMessagesCount.toString();
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    },
  },

  actions: {
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data;

            commit("SET_USERINFO", data);
            commit("SET_FULLNAME", data.Name + " " + data.Famil);
            commit("SET_NUM_SYSTEM", data.Num_System);
            commit("SET_AVATAR", data.ImageUrl);
            commit("SET_UNREAD_MESSAGE_COUNT", data.UnreadMessagesCount);
            setSlider(
              data.Name + " " + data.Famil,
              data.Num_System,
              data.UnreadMessagesCount,
              data.ImageUrl,
              data.Jensiat,
            );

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    LogOut({ commit }) {
      commit("SET_USERINFO", {});
      commit("SET_TOKEN", "");
      commit("SET_NUM_SYSTEM", "");
      commit("SET_FULLNAME", "");
      commit("SET_AVATAR", "");
      removeToken();
      document.location =
        process.env.VUE_APP_API_ENDPOINT + "/Home/SignoutCleanup";
    },

    setSelectedDashboard({ commit, dispatch }, Dashboard) {
      commit("SET_SELECTED_DASHBOARD", Dashboard);
    },
    setInboxCount({ commit }, inbox_count) {
      commit("SET_INBOX_COUNT", inbox_count);
    },
  },
};
